"use client";

import { c as _c } from "react/compiler-runtime";
import { Grid } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { PAGE_SIZE } from "../constants";
import { CollectionTraitItemsCard } from "./CollectionTraitItemsCard";
const ITEMS = range(PAGE_SIZE).map(() => undefined);
export function CollectionTraitItemsGridSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Grid context={undefined} itemKey={_temp} items={ITEMS} renderItem={CollectionTraitItemsCard} size="md" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, index) {
  return String(index);
}